import React, { useContext, useEffect, useRef, useState } from 'react'
import BoxPlotChart from './BoxPlotChart'
import FilterModeSelector from './FilterModeSelector'
import { DataContext } from './DataContext'

const BoxPlotWrapper = ({
    containerRef,
    isCollapsed,
    isExpanded,
    displayFilterModeDropdown,
    setDisplayFilterModeDropdown,
}) => {
    const { filterMode, setFilterMode, chartRef } = useContext(DataContext)
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 })

    // Function to update dimensions based on container size
    const updateDimensions = () => {
        if (containerRef.current && !isCollapsed) {
            const container = containerRef.current
            setDimensions({
                width: container.clientWidth - 40, // Subtracting padding/margins
                height: container.clientHeight
            })
        }
    }

    useEffect(() => {
        // Initial measurement
        updateDimensions()

        // Set up resize observer to track container size changes
        const resizeObserver = new ResizeObserver(() => {
            updateDimensions()
        })

        if (containerRef.current) {
            resizeObserver.observe(containerRef.current)
        }

        // Set up window resize listener as fallback
        const handleResize = () => {
            updateDimensions()
        }
        window.addEventListener('resize', handleResize)

        // Cleanup
        return () => {
            resizeObserver.disconnect()
            window.removeEventListener('resize', handleResize)
        }
    }, [containerRef])

    return (
        <div
            className={`dashboardPanelBody ${
                isCollapsed && !isExpanded ? 'is-collapsed' : ''
            }`}
        >
            <FilterModeSelector
                displayFilterModeDropdown={displayFilterModeDropdown}
                setDisplayFilterModeDropdown={setDisplayFilterModeDropdown}
                setFilterMode={setFilterMode}
                filterMode={filterMode}
            />
            <div ref={chartRef} className="chart">
                <BoxPlotChart
                    isExpanded={isExpanded}
                    staticHeightWidth={{
                        width: dimensions.width,
                        height: isExpanded
                            ? dimensions.height - (displayFilterModeDropdown ? 75 : 0) - 100
                            : Math.min(dimensions.height, 600),
                    }}
                />
            </div>
        </div>
    )
}

export default BoxPlotWrapper